import { useEffect } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { getFolderContent } from '../features/media-file/domain/use-cases/get-folder-content'
import { QueryKeys } from '../utils/query-keys'
import { fetchSoundDesigns } from '@/features/sound-design/domain/use-cases/fetch-sound-designs.ts'
import { fetchSoundEffects } from '@/features/sound-effect/domain/use-cases/fetch-sound-effects.ts'

interface UsePrefetchQueriesOptions {
  enabled?: boolean
}

export const usePrefetchQueries = ({
  enabled = true,
}: UsePrefetchQueriesOptions = {}): void => {
  const queryClient = useQueryClient()

  useEffect(() => {
    if (!enabled) return

    void queryClient.prefetchQuery({
      queryKey: [QueryKeys.MediaFolderContent, undefined],
      queryFn: async () => await getFolderContent(undefined),
    })

    void queryClient.prefetchInfiniteQuery({
      queryKey: [QueryKeys.SoundEffects, {}, ''],
      queryFn: async ({ pageParam = 0 }) =>
        await fetchSoundDesigns(pageParam, {}, ''),
      initialPageParam: 0,
    })

    void queryClient.prefetchInfiniteQuery({
      queryKey: [QueryKeys.SoundDesigns, {}, ''],
      queryFn: async ({ pageParam = 0 }) =>
        await fetchSoundEffects(pageParam, { tags: [] }, ''),
      initialPageParam: 0,
    })
  }, [enabled, queryClient])
}
